<mat-spinner *ngIf="!init" color="primary" diameter="48"></mat-spinner>
<div class="container" *ngIf="init">
  <button
    (click)="openTab(subproject)"
    mat-flat-button
    class="btn-gray"
    style="margin-bottom: 10px;"
    *ngFor="let subproject of this.project.subProjects"
    [ngClass]="{ active: getActive(subproject) }"
  >
    {{ getTitle(subproject) }}
    <span *ngIf="subproject.showExecutedCheck">
      <mat-icon
        class="small-medium-icon translate-check"
        svgIcon="check"
      ></mat-icon>
    </span>
  </button>
</div>
<create-view-picker
  *ngIf="init"
  [project]="project"
  [subProject]="activeSubProject"
  [submitProjectResult]="submitProjectResult"
  [adminCreate]="adminCreate"
  (submitProject)="doSubmitProject()"
  (updateOtherContacts)="setSelectedOtherContacts($event)"
></create-view-picker>
